import {   
    Collapse,   
    Table,
    TableBody,
    TableCell,
    TableRow,
  } from "@material-ui/core";
  import * as React from "react";
  import { useEffect, useState } from "react";
  import Rest from "src/services/Rest";
  import './ShareEvolutionWeekly.scss';
import ItemValueWeekly from "./ItemValueWeekly";

  
  interface ISubShareEvolutionWeeklyProps {    
    rowsOpen: number;  
    grupo: number; 
    getFilter: (pagination: boolean) => void;
   }  
  
  export default function SubTableShareEvolutionWeekly( props: ISubShareEvolutionWeeklyProps) {
   
   const {rowsOpen, grupo, getFilter} = props;
   const [lojas, setLojas] = useState([])  
  
   const columns = [

    {  nome: 'nome',
       render: (item: any) =><div style={{minWidth: '210px'}}>{item.nome}</div>},    
       {render: (item: any) => <ItemValueWeekly  value={item.semana_atual} share={item.semana_atual_share} valueAnterior={item.semana_anterior_1}/> }, 
       {render: (item: any) => <ItemValueWeekly  value={item.semana_anterior_1} share={item.semana_anterior_1_share} valueAnterior={item.semana_anterior_2} /> },    
       {render: (item: any) => <ItemValueWeekly  value={item.semana_anterior_2} share={item.semana_anterior_2_share} valueAnterior={item.semana_anterior_3}/> },
       {render: (item: any) => <ItemValueWeekly  value={item.semana_anterior_3} share={item.semana_anterior_3_share} valueAnterior={item.semana_anterior_4}/> },    
       {render: (item: any) => <ItemValueWeekly  value={item.semana_anterior_4} share={item.semana_anterior_4_share} />}    
   ]
  
    const search = () => {       
      const api = getFilter(false) as any;
      let endPoint = `share-evolution-weekly/lojas/${grupo}`; 

      if(api && api !== '') {
        endPoint += api
      }

      Rest.GET(endPoint, null)
        .then((response) => response.json())
        .then((result: any) => {
          if (result != null && result !== undefined) {        
            setLojas(result); 
          }          
        });
    };   
  
    const getCellRow = (row: any, item: any) => {        
      return <TableCell  align="center"  style={{textAlign: 'center', borderLeft: '1px solid #e0e0e0'}} key={getKey()} >{item.render(row)}</TableCell>
    }

    const getKey = () => {
        return Math.random() * 12;
      };     
    
    useEffect(() => {
       search()
    }, [])

    return (     
        <TableRow key={getKey()} className="sub-row">
            <TableCell style={{ paddingBottom: 0, paddingTop: 0 , paddingLeft: '0px', paddingRight: '0px', borderLeft: 'unset !important'}} colSpan={14}> 
                <Collapse timeout="auto" in={rowsOpen === grupo} unmountOnExit={true}>                
                <div className="container-sub-table">
                 <Table>                  
                    <TableBody>  
                     {lojas.map((row: any) => (
                        <>
                        <TableRow key={getKey()} >  
                         <TableCell style={{borderLeft: '1px solid #e0e0e0'}}> <div style={{minWidth: '48px', maxWidth: '128px'}}/></TableCell>                        
                         {columns.map((v:any) => (
                                 getCellRow(row, v)
                           ))}
                        </TableRow>
                        </>
                     ))}
                    </TableBody>
                 </Table>
                 </div>
                </Collapse>
            </TableCell>
        </TableRow>       
    )
                         
    
  }
  


// WEBPACK FOOTER //
// ./src/component/publisher/sale/evolution-weekly/SubTableEvolutionWeekly.tsx